
import React from "react";
import { Container, Truck } from "lucide-react";

const ServiceDescription: React.FC = () => {
  return (
    <div className="flex flex-col justify-center">
      <h2 className="text-2xl font-bold text-fabre-gray mb-6">Notre service de location de bennes</h2>
      <p className="text-gray-600 mb-4">
        Groupe Fabre Environnement propose une large gamme de bennes et conteneurs 
        adaptés à tous types de déchets pour les professionnels, collectivités ou particuliers.
      </p>
      <p className="text-gray-600 mb-4">
        Que vous ayez besoin d'une solution temporaire ou permanente, nos experts 
        vous conseilleront sur le choix de benne le plus adapté à vos besoins.
      </p>
      <div className="flex items-center mt-4">
        <Container className="text-fabre-green h-8 w-8 mr-3" />
        <p className="font-medium">Différentes tailles de bennes disponibles</p>
      </div>
      <div className="flex items-center mt-4">
        <Truck className="text-fabre-green h-8 w-8 mr-3" />
        <p className="font-medium">Livraison et enlèvement rapides</p>
      </div>
    </div>
  );
};

export default ServiceDescription;
